import apiClient from './apiClient';

export type SettingValueType = 'string' | 'bool' | 'url' | 'int';

export interface SettingRow {
  value: string | boolean | number | null;
  codeDefault: string | boolean | number | null;
  isOverridden: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
  valueType: SettingValueType;
  enumOptions?: (string | number)[];
  multiline?: boolean;
}

export interface SettingsState {
  overrideSafe: Record<string, SettingRow>;
  structural: Record<string, { value: string | boolean | number | null }>;
}

class SettingsService {
  async getSettings(): Promise<SettingsState> {
    const res = await apiClient.get<SettingsState>('/api/settings');
    return res.data;
  }

  async updateSetting(
    key: string,
    value: string | boolean | number | null,
  ): Promise<SettingsState> {
    const res = await apiClient.put<SettingsState>(
      `/api/settings/${encodeURIComponent(key)}`,
      { value },
    );
    return res.data;
  }

  async deleteSetting(key: string): Promise<SettingsState> {
    const res = await apiClient.delete<SettingsState>(
      `/api/settings/${encodeURIComponent(key)}`,
    );
    return res.data;
  }
}

export const settingsService = new SettingsService();
